import { HttpClient } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject, tap } from "rxjs";
import { User } from "src/app/models/user.model";
import { environment } from "src/environments/enviroment.prod";
import { ProjectCartService } from "src/app/services/project-cart/project-cart.service";

export interface AuthResponse {
  id: number;
  name: string;
  type: string,
  TRDR: string;
  // Laravel serialises the isAdmin tinyint as 1/0, but a user created during
  // token exchange is returned before a DB refresh and arrives as a boolean.
  isAdmin: number | boolean;
  token: string;
}

@Injectable({
  providedIn: 'root'
})

export class AuthService {

  private _user = new BehaviorSubject<User | null>(null);

  private userKey = 'pca_user';
  constructor(private _http: HttpClient, private router: Router, private injector: Injector) { }

  get user() {
    return this._user.asObservable();
  }


  logout() {
    this._user.next(null);
    localStorage.removeItem(this.userKey);

    // Drop the active project too. Without this the next person to sign in on
    // this browser inherits the previous user's cart in memory, and every
    // write to it is rejected by the backend's ownership check.
    // Resolved lazily: ProjectCartService's dependency graph reaches back here.
    this.injector.get(ProjectCartService).abandonProject();

    this.router.navigate(['/login']);
  }

  login(username: string, password: string) {
    return this._http.post<AuthResponse>(environment.apiLink + '/login', { name: username, password: password, isApp: true }).pipe(
      tap(this.setUserData.bind(this))
    )
  }

  private setUserData(user: AuthResponse) {
    const userData = new User(user.id, user.name, user.type, user.TRDR, !!user.isAdmin, user.token);
    this._user.next(userData);
    this.storeAuthData(user);
  }

  private storeAuthData(user: AuthResponse) {
    localStorage.setItem(this.userKey, JSON.stringify(user));
  }

  autoLogin() {
    const parsedData = JSON.parse(localStorage.getItem(this.userKey) || 'null') as AuthResponse;
    if (!parsedData) return this._user.next(null);
    const user = new User(parsedData.id, parsedData.name, parsedData.type, parsedData.TRDR, !!parsedData.isAdmin, parsedData.token);
    this._user.next(user);
  }

  exchangeToken(token: string) {
    return this._http.post<AuthResponse>(environment.apiLink + '/auth/exchange-token', { token: token }).pipe(
      tap(this.setUserData.bind(this))
    );
  }

}
